import { render, staticRenderFns } from "./history_request.vue?vue&type=template&id=ff3c811e&"
import script from "./history_request.vue?vue&type=script&lang=js&"
export * from "./history_request.vue?vue&type=script&lang=js&"
import style0 from "./history_request.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports